import React, { useEffect, useState } from "react";
import { Container, Card, Form, Row, Col } from "react-bootstrap";
import Select from "react-select";
import { useDispatch } from "react-redux";
import { useParams, useNavigate, Link } from "react-router-dom";

import { getpackage } from "../../store/slices/package";
import { generateQuotation } from "../../store/slices/quotation";

export default function CreateQuotation() {
  const { id } = useParams(); // leadId
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const [form, setForm] = useState({
    packageId: "",
    travelDate: "",

    numberOfAdults: "",
    numberOfChildren: "",

    rooms: "",
    extraBeds: "",
    childWithBed: "",

    discountAmount: "",
  });

  useEffect(() => {
    fetchPackages();
  }, []);

  const fetchPackages = async (search = "") => {
    try {
      const res = await dispatch(
        getpackage({
          search,
        })
      ).unwrap();

      setPackages(res.data || []);
    } catch (err) {
      console.error(err);
      alert("Failed to load packages");
    }
  };


  const handlePackageChange = (selected) => {
    setForm((prev) => ({
      ...prev,
      packageId: selected?.value,
    }));

    setErrors((prev) => ({
      ...prev,
      packageId: "",
    }));
  };


  const handleChange = (field, value) => {
    setForm((prev) => ({
      ...prev,
      [field]: value,
    }));

    let error = "";

    switch (field) {
      case "numberOfAdults":
        if (!value || Number(value) <= 0) {
          error = "Please enter valid adults count";
        }
        break;



      case "travelDate":
        if (!value) {
          error = "Please select travel date";
        }
        break;

      case "packageId":
        if (!value) {
          error = "Please select package";
        }
        break;

      default:
        break;
    }

    setErrors((prev) => ({
      ...prev,
      [field]: error,
    }));
  };
  const validateForm = () => {
    let newErrors = {};

    if (!form.packageId) {
      newErrors.packageId = "Please select a package";
    }

    if (!form.travelDate) {
      newErrors.travelDate = "Please select travel date";
    }

    if (!form.numberOfAdults || Number(form.numberOfAdults) <= 0) {
      newErrors.numberOfAdults = "Please enter valid adults count";
    }

    // if (form.numberOfChildren === "") {
    //   newErrors.numberOfChildren = "Please enter children count";
    // }

    // if (!form.rooms || Number(form.rooms) <= 0) {
    //   newErrors.rooms = "Please enter valid rooms count";
    // }

    // if (form.extraBeds === "") {
    //   newErrors.extraBeds = "Please enter extra beds count";
    // }

    // if (form.childWithBed === "") {
    //   newErrors.childWithBed = "Please enter child without bed count";
    // }

    // if (form.discountAmount === "") {
    //   newErrors.discountAmount = "Please enter discount amount";
    // }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };
  const getTomorrowDate = () => {
    const today = new Date();
    today.setDate(today.getDate() + 1);

    return today.toISOString().split("T")[0];
  };

  const handleSubmit = async () => {
    const isValid = validateForm();

    if (!isValid) {
      return;
    }

    try {
      setLoading(true);

      const payload = {
        leadId: id,
        ...form,
      };

      const res = await dispatch(generateQuotation(payload)).unwrap();

      const quotationId = res.data?._id;

      if (!quotationId) {
        throw new Error("Quotation ID missing");
      }

      navigate(`/admin/quotation/${quotationId}/preview`);
    } catch (err) {
      console.error(err);
      alert(err?.message || "Failed to generate quotation");
    } finally {
      setLoading(false);
    }
  };


  return (
    <>
      <div className="breadcrumb-bar mb-2">
        <div className="breadcrumb-left">
          <Link to="/admin/home" className="breadcrumb-link active">
            Home
          </Link>

          <span className="breadcrumb-separator">|</span>

          <Link onClick={() => navigate(-1)} className="breadcrumb-link active">
            Lead Details
          </Link>

          <span className="breadcrumb-separator">|</span>

          <span className="breadcrumb-link inactive">Create Quotation</span>
        </div>
      </div>
      <Container>
        <Card className="p-4">
          <Row>
            {/* PACKAGE */}
            <Col md={6} className="mb-3">
              <Form.Label>Package</Form.Label>

              <Select
                placeholder="Select Package"
                options={packages.map((p, index) => ({
                  label: `${index + 1}. ${p.title}`,
                  value: p._id,
                }))}
                onChange={handlePackageChange}
              />
              {errors.packageId && (
                <div style={{ color: "red", fontSize: "13px" }}>
                  {errors.packageId}
                </div>
              )}
            </Col>

            {/* TRAVEL DATE */}
            <Col md={4} className="mb-3">
              <Form.Label>Travel Date</Form.Label>

              <Form.Control
                type="date"
                value={form.travelDate}
                min={getTomorrowDate()}
                onChange={(e) => handleChange("travelDate", e.target.value)}
              />
              {errors.travelDate && (
                <div style={{ color: "red", fontSize: "13px" }}>
                  {errors.travelDate}
                </div>
              )}
            </Col>

            <Col md={2} className="mb-3"></Col>

            <Col md={4} className="mb-3">
              <Form.Label>Adults</Form.Label>

              <Form.Control
                type="text"
                value={form.numberOfAdults}
                placeholder="Enter count"
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9]/g, "");

                  if (Number(value) <= 50 || value === "") {
                    handleChange("numberOfAdults", value);
                  }
                }}
              />
              {errors.numberOfAdults && (
                <div style={{ color: "red", fontSize: "13px", marginTop: "5px" }}>
                  {errors.numberOfAdults}
                </div>
              )}
            </Col>

            {/* CHILDREN */}
            <Col md={4} className="mb-3">
              <Form.Label>Children</Form.Label>

              <Form.Control
                type="text"
                value={form.numberOfChildren} placeholder="Enter count"
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9]/g, "");

                  if (Number(value) <= 10 || value === "") {
                    handleChange("numberOfChildren", value);
                  }
                }}
              />
              {errors.numberOfChildren && (
                <div style={{ color: "red", fontSize: "13px", marginTop: "5px" }}>
                  {errors.numberOfChildren}
                </div>
              )}
            </Col>

            {/* DISCOUNT */}
            <Col md={4} className="mb-3">
              <Form.Label>Discount Amount</Form.Label>

              <Form.Control
                type="text"
                value={form.discountAmount} placeholder="Enter amount"
                onChange={(e) =>
                  handleChange(
                    "discountAmount",
                    e.target.value.replace(/[^0-9]/g, "")
                  )
                }
              />
            </Col>

            {/* ROOMS */}
            <Col md={4} className="mb-3">
              <Form.Label>Rooms</Form.Label>

              <Form.Control
                type="text"
                value={form.rooms} placeholder="Enter count"
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9]/g, "");

                  if (Number(value) <= 20 || value === "") {
                    handleChange("rooms", value);
                  }
                }}
              />
              {errors.rooms && (
                <div style={{ color: "red", fontSize: "13px", marginTop: "5px" }}>
                  {errors.rooms}
                </div>
              )}
            </Col>

            {/* EXTRA BEDS */}
            <Col md={4} className="mb-3">
              <Form.Label>Extra Beds (Above 12 Years)</Form.Label>

              <Form.Control
                type="text"
                value={form.extraBeds} placeholder="Enter count"
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9]/g, "");

                  if (Number(value) <= 10 || value === "") {
                    handleChange("extraBeds", value);
                  }
                }}
              />
            </Col>

            {/* CHILD WITH BED */}
            <Col md={4} className="mb-3">
              <Form.Label>Child Without Bed (5-12 Years)</Form.Label>

              <Form.Control
                type="text" placeholder="Enter count"
                value={form.childWithBed}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9]/g, "");

                  if (Number(value) <= 10 || value === "") {
                    handleChange("childWithBed", value);
                  }
                }}
              />
            </Col>
          </Row>

          {/* SUBMIT */}
          <div className="d-flex justify-content-center mt-4">
            <button
              type="button"
              className="cancel-btn me-3"
              onClick={() => navigate(-1)}
            >
              Cancel
            </button>
            <button
              className="submit-btn"
              onClick={handleSubmit}

              disabled={loading}
            >
              {loading ? "Generating Quotation..." : "Submit"}
            </button>
          </div>
        </Card>
      </Container>
    </>
  );
}
